import { Equalizer, LiveBadge } from "../../components/viz/OnAir";
import { useNow } from "../../hooks/useNow";
import type { Stream } from "../../lib/api/types";
import { formatDateTime } from "../../lib/format";
import { PLATFORM_LABEL, uptimeMs } from "../../lib/stream-status";
import { formatClock } from "../../lib/uptime";

/** The dark "on air" panel a running stream gets on its page: a clock that ticks every second, as on the landing page. */
export function OnAirBoard({ s }: { s: Stream }) {
  const now = useNow(1_000);
  const up = uptimeMs(s, now);
  if (up === null) return null;
  return (
    <div className="flex flex-col gap-4 bg-ink p-5 text-white">
      <div className="flex items-center justify-between gap-3">
        <LiveBadge />
        <span className="font-mono text-xs text-board-muted">{PLATFORM_LABEL[s.platform]} · {s.quality === "4k" ? "4K" : "HD"} {s.fps} fps</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="font-mono text-xs uppercase tracking-widest text-board-muted">on air for</span>
        <span className="font-mono text-4xl font-bold tracking-tight tabular-nums sm:text-5xl" role="timer" aria-live="off">{formatClock(up)}</span>
        <span className="text-board-muted">since {formatDateTime(s.runStartedAt)}</span>
      </div>
      <Equalizer bars={48} />
    </div>
  );
}
